<template>

    <div class="sub">

        <span class="sub__name text-xlSemibold ellipsis-text">
            <div class="not-seen" v-show="subscription.notSeen"></div>
            <span>{{ subscription.name }}</span>
        </span>
        <p class="text-baseRegular-2 color__moon mt__4">{{ subscription.sender }}</p>
        <p class="spoum-bloc">
            <span class="spoum-badge" v-show="Subscription.isSpoum(subscription)">{{ $t('spam') }}</span>
        </p>

        <div class="sub__bloc">
            <div class="sub__bloc__left">
                <div class="sub__bloc__top">
                    <img src="/img/newsletters-v2/mail-open-white.svg" class="img__24">
                </div>

                <div class="sub__bloc__bottom color__white">
                    <p class="text-baseMedium">{{ $t('cleaning_cards_opening_rate') }}</p>
                    <p class="title-lBold">{{ subscription.openRate || 0 }} %</p>
                </div>
            </div>
            <div class="sub__bloc__right">
                <div class="sub__bloc__top">
                    <img src="/img/newsletters-v2/mail-white.svg" class="img__24">
                </div>

                <div class="sub__bloc__bottom color__white">
                    <p class="text-baseMedium">{{ $tc('cleaning_cards_received_emails', subscription.length) }}</p>
                    <p class="title-lBold">{{ subscription.count }}</p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Subscription from '@/helpers/subscription'


export default {

    name: 'subscriptions',

    props: {
        subscription: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },

    computed: {
        Subscription() {
            return Subscription
        }
    }
}

</script>

<style lang="scss" scoped>

@import "@/style/spoum.scss";

.sub {
    display: flex;
    flex-direction: column;
    background-color: #F9FAFC;
    width: 100%;
    text-align: start;
    padding: 24px 20px;
    border-radius: 12px;
    box-shadow: 0 8px 32px 0 rgba(17, 17, 26, 0.05), 0 4px 16px 0 rgba(17, 17, 26, 0.1);
    max-width: 440px;

    .spoum-bloc {
        margin-top: 20px;
    }

    &__name {
        display: flex;
        align-items: center;
    }

    &__bloc {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        margin-top: 20px;
        text-align: start;

        &__top {
            width: 40px;
            height: 40px;
            border-radius: 10px;
            background-color: rgba(255, 255, 255, 0.24);
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &__bottom {

        }

        &__left {
            justify-content: space-between;
            flex-direction: column;
            display: flex;
            margin: 0 4px 0 0;
            flex: 1;
            padding: 12px;
            border-radius: 16px;
            background: linear-gradient(326.54deg, #5CABA4 1.22%, #5EA774 100%);

            &:lang(ar-sa) {
                margin: 0 0 0 4px;
            }
        }

        &__right {
            justify-content: space-between;
            flex-direction: column;
            display: flex;
            margin: 0 0 0 4px;
            flex: 1;
            padding: 12px;
            border-radius: 16px;
            background: linear-gradient(220.05deg, #3A4F41 12.84%, #43654E 97.34%);

            &:lang(ar-sa) {
                //margin: 0 4px 0 0;
                //align-items: flex-end;
            }
        }
    }
}

.not-seen {
    width: 8px;
    height: 8px;
    border-radius: 8px;
    background-color: $aquamarine;
    margin-right: 8px;
}

</style>
